const getVariantPriceFromData = (variant: any, productPrice: number, filteredOptions: any) => {
  let basePrice = Number(productPrice) || 0;
  Object.keys(filteredOptions).forEach((optionId: string) => {
    const filteredVariant = filteredOptions[optionId];
    if (filteredVariant) {
      const variantPrice = filteredVariant.price || 0;
      basePrice += variantPrice;
    }
  });
  const variantPriceValue = Number(variant?.price_value || 0);
  return Math.ceil((basePrice * variantPriceValue) / 100);
};
const getVariantOldPriceFromData = (variant: any, productPrice: number, filteredOptions: any) => {
  let basePrice = Number(productPrice) || 0;
  Object.keys(filteredOptions).forEach((optionId: string) => {
    const filteredVariant = filteredOptions[optionId];
    if (filteredVariant) {
      const variantPrice = filteredVariant.price_old || 0;
      basePrice += variantPrice;
    }
  });
  const variantPriceValue = Number(variant?.price_old_value || 0);
  return Math.ceil((basePrice * variantPriceValue) / 100);
};

const getTotalPriceOptions = (options: any, productPrice: any, listOptions: any) => {
  let _seletedPriceValue = 0;
  listOptions.forEach((option: any, index: number) => {
    const optionId = String(option.id);
    const variant = options[optionId];
    if (!variant) return;

    let sumPrice = variant.price || 0;
    if ((variant?.priceRelationGroups || []).length > 0) {
      const _productOptions = index > 0 ? listOptions.slice(0, index) : [];
      const filteredOption = Object.keys(options).reduce((acc: any, key: string) => {
        if (
          _productOptions.some((opt: any) => String(opt?.id) === String(key)) &&
          (variant.priceRelationGroups || []).some((groupId: any) => String(groupId?.id || groupId) === String(key))
        ) {
          acc[key] = options[key];
        }
        return acc;
      }, {});
      sumPrice = getVariantPriceFromData(variant, productPrice, filteredOption);
    }
    _seletedPriceValue += sumPrice;
  });
  return _seletedPriceValue;
};
const getTotalOldPriceOptions = (options: any, productPrice: any, listOptions: any) => {
  let _seletedPriceValue = 0;
  listOptions.forEach((option: any, index: number) => {
    const optionId = String(option.id);
    const variant = options[optionId];
    if (!variant) return;

    let sumPrice = variant.price_old || 0;
    if ((variant?.priceRelationGroups || []).length > 0) {
      const _productOptions = index > 0 ? listOptions.slice(0, index) : [];
      const filteredOption = Object.keys(options).reduce((acc: any, key: string) => {
        if (
          _productOptions.some((opt: any) => String(opt?.id) === String(key)) &&
          (variant.priceRelationGroups || []).some((groupId: any) => String(groupId?.id || groupId) === String(key))
        ) {
          acc[key] = options[key];
        }
        return acc;
      }, {});
      sumPrice = getVariantOldPriceFromData(variant, productPrice, filteredOption);
    }
    _seletedPriceValue += sumPrice;
  });
  return _seletedPriceValue;
}

/**
 * Цена варианта с учётом уже выбранных опций из priceRelationGroups.
 * Считаем по данным selectedOptions, а не по DOM — иначе в модалке
 * остаётся устаревшая цена, если зависимые параметры выбраны раньше.
 */
const getSelectedVariantForRelation = (
  selectedOptions: Record<string, any>,
  groupId: any
) => {
  const key = String(groupId?.id || groupId);
  const rawKey = groupId?.id ?? groupId;
  return selectedOptions?.[key] || selectedOptions?.[rawKey] || null;
};

const getDisplayVariantPrice = (
  variant: any,
  productPrice: number,
  selectedOptions: Record<string, any> = {}
): number => {
  const groups = variant?.priceRelationGroups || [];
  if (groups.length <= 0) {
    return Number(variant?.price || 0);
  }

  const filteredOptions = groups.reduce((acc: Record<string, any>, groupId: any) => {
    const key = String(groupId?.id || groupId);
    const selectedVariant = getSelectedVariantForRelation(selectedOptions, groupId);
    if (selectedVariant) {
      acc[key] = selectedVariant;
    }
    return acc;
  }, {});

  return getVariantPriceFromData(variant, productPrice, filteredOptions);
};

const getDisplayVariantOldPrice = (
  variant: any,
  productOldPrice: number,
  selectedOptions: Record<string, any> = {}
): number => {
  const groups = variant?.priceRelationGroups || [];
  if (groups.length <= 0) {
    return Number(variant?.price_old || 0);
  }

  const filteredOptions = groups.reduce((acc: Record<string, any>, groupId: any) => {
    const key = String(groupId?.id || groupId);
    const selectedVariant = getSelectedVariantForRelation(selectedOptions, groupId);
    if (selectedVariant) {
      acc[key] = selectedVariant;
    }
    return acc;
  }, {});

  return getVariantOldPriceFromData(variant, productOldPrice, filteredOptions);
};

/** @deprecated используйте getDisplayVariantPrice — расчёт по DOM даёт устаревшие цены */
const getVariantPriceRelationGroups = (productPrice: number, variantPrice: number, options: any) => {
  const _variantPrice = Number(variantPrice) || 0;

  let _seletedPriceValue = Number(productPrice) || 0;
  Object.keys(options).forEach((optionId: any) => {
    const elOption: any = document.querySelector(`[data-select-option-id="${optionId}"]`);
    if (!!elOption) {
      const elPrice = elOption.querySelector(`[data-price]`);
      const priceValue: string = elPrice?.getAttribute('data-price');
      const parsedPrice = Number.parseFloat(priceValue) || 0;
      _seletedPriceValue = _seletedPriceValue + parsedPrice;
    }
  });
  const result = (_seletedPriceValue * _variantPrice) / 100;
  return Math.ceil(result);
}
/** @deprecated используйте getDisplayVariantOldPrice — расчёт по DOM даёт устаревшие цены */
const getVariantOldPriceRelationGroups = (productPrice: number, variantPrice: number, options: any) => {
  const _variantPrice = Number(variantPrice) || 0;

  let _seletedPriceValue = Number(productPrice) || 0;
  Object.keys(options).forEach((optionId: any) => {
    const elOption: any = document.querySelector(`[data-select-option-id="${optionId}"]`);
    if (!!elOption) {
      const elPrice = elOption.querySelector(`[data-old-price]`);
      const priceValue: string = elPrice?.getAttribute('data-old-price') || '0';
      const parsedPrice = Number.parseFloat(priceValue) || 0;
      _seletedPriceValue = _seletedPriceValue + parsedPrice;
    }
  });

  const result = (_seletedPriceValue * _variantPrice) / 100;
  return Math.ceil(result);
}

/**
 * Подпись для админов: "(зависит от: Опция1, Опция2)" по priceRelationGroups.
 */
const getPriceRelationDependsOnLabel = (
  variant: any,
  listOptions: any[] = []
): string => {
  const groups = variant?.priceRelationGroups || [];
  if (!groups.length) {
    return '';
  }

  const names = groups
    .map((groupId: any) => {
      if (groupId?.name) {
        return String(groupId.name).trim();
      }
      const id = String(groupId?.id || groupId);
      const option = (listOptions || []).find((opt: any) => String(opt?.id) === id);
      return String(option?.name || '').trim();
    })
    .filter(Boolean);

  // Убираем дубли, сохраняя порядок
  const uniqueNames = names.filter((name: string, index: number) => names.indexOf(name) === index);
  if (!uniqueNames.length) {
    return '';
  }

  return `(зависит от: ${uniqueNames.join(', ')})`;
};

/**
 * После выбора опции собирает уже выбранные опции, чья цена зависит от неё
 * (через priceRelationGroups), и формирует один текст подсказки.
 */
const getDependentPriceUpdateHintMessage = (
  changedOption: any,
  selectedOptions: Record<string, any>,
  listOptions: any[]
): string => {
  const changedOptionId = String(changedOption?.id);
  if (!changedOptionId || !changedOption?.name) {
    return '';
  }

  const dependentNames: string[] = [];
  listOptions.forEach((option: any) => {
    const optionId = String(option?.id);
    if (!optionId || optionId === changedOptionId || !option?.name) {
      return;
    }

    const selectedVariant = selectedOptions[optionId] || selectedOptions[option.id];
    if (!selectedVariant) {
      return;
    }

    const groups = selectedVariant.priceRelationGroups || [];
    const dependsOnChanged = groups.some(
      (groupId: any) => String(groupId?.id || groupId) === changedOptionId
    );
    if (!dependsOnChanged) {
      return;
    }

    dependentNames.push(option.name);
  });

  if (dependentNames.length === 0) {
    return '';
  }

  if (dependentNames.length === 1) {
    return `После того как Вы выбрали ${changedOption.name}, цена параметра ${dependentNames[0]} обновилась.`;
  }

  const lastName = dependentNames[dependentNames.length - 1];
  const otherNames = dependentNames.slice(0, -1).join(', ');
  return `После того как Вы выбрали ${changedOption.name}, цена параметров ${otherNames} и ${lastName} обновилась.`;
};

export {
  getTotalPriceOptions,
  getTotalOldPriceOptions,
  getDisplayVariantPrice,
  getDisplayVariantOldPrice,
  getPriceRelationDependsOnLabel,
  getVariantPriceRelationGroups,
  getVariantOldPriceRelationGroups,
  getDependentPriceUpdateHintMessage
}
